







































































































import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

import StudioSocial from '@/web/components/navigation/StudioSocial.vue';
import { getConfig } from '@/web/utils/configuration';
import HMTipButton from '@/web/components/common/HMTipButton.vue';

export default Vue.extend({
  name: 'StudioFooter',
  components: {
    HMTipButton,
    StudioSocial,
  },
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      selectedTemplate: 'studio/selectedTemplate',
      isExpired: 'studio/isExpired',
      teacherStudioUrl: 'user/teacherStudioUrl',
      studentCommunityProfileFirstName: 'user/studentCommunityProfileFirstName',
    }),
    ...mapState('user', ['teacher']),
    config() {
      return getConfig();
    },
  },
});
